import React from 'react';
import ProductsForm from './ProductsForm'; // Adjust path
import { useParams } from 'react-router-dom';

const EditProductPage = () => {
  const { id } = useParams();

  return (
    <>
     {id ? <ProductsForm formType='edit' currentProductId={id} /> : 'Loading...'}
    </>
  );
};

export default EditProductPage;